import React from "react";
import BreadcrumpTemp from "../Template/BreadcrumpTemp";
import { useNavigate } from "react-router-dom";

// Import your Defence images
import img1 from "../../img/defence/img1.jpg";
import img2 from "../../img/defence/img2.jpg";
import img3 from "../../img/defence/img3.jpg";
import img4 from "../../img/defence/img4.jpg";
import img5 from "../../img/defence/img5.jpg";
import img6 from "../../img/defence/img6.jpg";
import img7 from "../../img/defence/img7.jpg";

import "../../style/articleEvent.css";

export default function DefenceEvents() {
  const navigate = useNavigate();

  const breadProp = {
    title: "Defence & Event",
    text: "This page will showcase all Defence related events and exhibitions.",
    arr: ["Home", "Defence & Event"],
  };

  const events = [
    { img: img1, text: "Showcasing the latest drone technology at Ex-Suraksha Chakra, highlighting advanced aerial capabilities.", path: "/defence/event1" },
    { img: img2, text: "Hands-on display of innovative drones organized by NDRF, New Delhi at the Ex-Suraksha Chakra event.", path: "/defence/event2" },
    { img: img3, text: "Insight into modern drone applications in disaster response and strategic operations", path: "/defence/event3" },
    { img: img4, text: "Hands-on display of innovative drones organized by NDRF, New Delhi at the Ex-Suraksha Chakra event.", path: "/defence/event4" },
    { img: img5, text: "Our team with defence personnel at the College of Military Engineering, Pune, showcasing advanced drone technology for defence applications.", path: "/defence/event5" },
    { img: img6, text: "Discussion with senior Army officials at the exhibition, presenting innovative drone solutions and their strategic use in defence operations.", path: "/defence/event6" },
    { img: img7, text: "Interactive session with defence instructors and officers, highlighting drone demonstrations and technical capabilities during the exhibition.", path: "/defence/event7" },
  ];

  return (
    <div>
      <BreadcrumpTemp bprops={breadProp} />
      <h1 style={{ textAlign: "center", marginTop: "20px" }}>
        Defence & Event
      </h1>
      <p style={{ textAlign: "center", marginTop: "10px" }}>
        This section highlights all major defence-related events and exhibitions, bringing together the latest innovations, technologies, and solutions in the security and defence sector. Stay updated on upcoming gatherings where industry leaders, professionals, and innovators connect.
      </p>

      <div className="art-div-cnt">
        <div className="event-lists">
          {events.map((event, index) => (
            <div key={index} className="event-card-t">
              <div
                className="event-card"
                onClick={() => navigate(event.path)}
              >
                <img src={event.img} alt={event.text} />
                <p>{event.text}</p>
                <div className="dual-line">
                  <div className="line1"></div>
                  <p>Read More</p>
                  <div className="line1"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
